import { DataTableRow, DataTableCell, DataTableCheckboxCell } from "~/react/ui/data-table"
import type { EmailAccount } from "~/react/components/email_accounts/email_accounts_filters"
import { isPendingAccount, resolveAccountStatus } from "../utils"
import type { ColumnDef } from "../utils"

type EmailAccountRowProps = {
  account: EmailAccount
  section?: string
  columns: ColumnDef[]
  statusData: Record<string, { status: string }>
  isSelected: boolean
  onToggleSelection: () => void
}

export function EmailAccountRow({
  account,
  section,
  columns,
  statusData,
  isSelected,
  onToggleSelection,
}: EmailAccountRowProps) {
  const uniqueId = account.id ?? `pending:${account.email}`
  const isPending = isPendingAccount(account)
  const status = resolveAccountStatus(account, statusData)

  return (
    <DataTableRow
      key={uniqueId}
      id={uniqueId}
      className={status === "disconnected" ? "h-data-table-row--error" : undefined}
    >
      <DataTableCheckboxCell
        aria-label={i18n.t("js.email_accounts_center.bulk.select_record_aria", { email: account.email })}
        recordId={uniqueId}
        section={section}
        checked={isSelected}
        disabled={isPending}
        onChange={onToggleSelection}
      />
      {columns.map((column) => (
        <DataTableCell key={column.id} sticky={column.sticky} {...column.cellProps}>
          {column.renderCell(account)}
        </DataTableCell>
      ))}
    </DataTableRow>
  )
}
